import { ReleaseNoteCreateResult } from "api/interfaces/settingsInterface.interface";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { useState } from "react";
import styled from "styled-components";
import { calcRem } from "styles/theme";

export default function ReleaseModal({
  onClickCancel,
  releaseNotesList,
}: {
  onClickCancel: () => void;
  releaseNotesList: any[];
}) {
  const Inner = ({ item }: { item: ReleaseNoteCreateResult }) => {
    const [showContent, setShowContent] = useState(false);
    return (
      <Wrapper>
        <Title
          onClick={() => setShowContent(!showContent)}
          data-testid="help-about-release-notes-title-set-show-content"
        >
          {item.version}
        </Title>
        {showContent && (
          <div dangerouslySetInnerHTML={{ __html: item.content }} />
        )}
      </Wrapper>
    );
  };
  return (
    <BigPopupTemplate title="Release Notes" onModal={onClickCancel}>
      {releaseNotesList.map((item: ReleaseNoteCreateResult) => (
        <Inner key={item.id} item={item} />
      ))}
    </BigPopupTemplate>
  );
}

const Wrapper = styled.div`
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-size: ${calcRem(14)};
  line-height: 1.5;
  width: 100%;
`;
const Title = styled.h1`
  font-size: ${calcRem(24)};
  margin-top: ${calcRem(15)};
  font-weight: bold;
  color: ${({ theme }) => theme.COLORS.BUTTONS2};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
